import { Total, Contact, Modalcontent, Profile, Item, Amount, Quantity, Discount, } from '../../../../Constant';
import { Btn, P } from '../../../../AbstractElements';
import InvoiceHeader from './InvoiceHeader';
import { Col, Label, Row, Table, Container, CardBody, Card, Nav, NavItem, NavLink, TabContent, TabPane, } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import InvoiceTotal from './InvoiceTotal';
import { PaymentColumns, PaymntColumns } from '../../../../Data/MockTable/TempData';
import DataTable from 'react-data-table-component';
import { getDataWithToken } from '../../../../Utils/restUtils';
import { getOrderRecentPayment } from '../../../../CommonURL';
import { useLocation, useNavigate } from 'react-router';

const ItemDescription = React.forwardRef((props, ref) => {
  const {
    invoiceDetail,
    statusColor,
    discountAmount,
    finalTotal,
    removeCoupon,  
  } = props;
    const style2 = { width: 85, fontSize: 13, padding: 5 };
    const [primarycolorTab, setprimarycolorTab] = useState('1');
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const orderId = params.get("order_id");
    const navigate = useNavigate();
      useEffect(() => {
        paymentData();
    }, [])
    const printSection = (value) => {
        
        return (
            <div ref={ref}>
                <div className='invoice invoice-print-styling'>
                    <Row>
                        {/* <Col> */}
                                <div className='mt-5'>
                                    <InvoiceHeader prop1={value} />
                                    {/* <InvoiceDescription prop1={value} /> */}  
                                    <div className="table-responsive invoice-table" id="table">
                                        <table className='table table-bordered'>
                                            <tbody>
                                                <tr>
                                                    <th className="item text-left">
                                                        {Item}
                                                    </th>
                                                    <th className="Rate text-end">
                                                        {Quantity}
                                                    </th>
                                                    <th className="Hours text-end">
                                                        {Amount}
                                                    </th>
                                                    <th className="Hours text-end">
                                                        {Discount}
                                                    </th>
                                                    <th className="subtotal text-end">
                                                        {Total}
                                                    </th>
                                                </tr>
                                              {value?.order_item?.map((item, index) => {
                                                
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>
                                                                <Label className='mb-2'>{item.name}</Label>
                                                            </td>
                                                            <td className=' text-end'>
                                                                <P attrPara={{ className: 'itemtext digits' }}>{item.quantity}</P>
                                                            </td>
                                                            <td  className=' text-end'>
                                                                <P attrPara={{ className: 'itemtext digits' }}>₹ {item.unit_price}</P>
                                                            </td>
                                                            <td className=' text-end'>
                                                                 <P className='itemtext digits'>
                                                                  {index === 0 ? (props.discountAmount ?? value?.discount_amount ?? 0) : ""}
                                                                 </P>
                                                            </td>
                                                            {/* <td className=' text-end'>
                                                                <P attrPara={{ className: 'itemtext digits' }}>{item.tax} %</P>
                                                            </td> */}
                                                            <td className=' text-end' >
                                                                <P attrPara={{ className: 'itemtext digits' }}>₹ {index === 0 ? (finalTotal ?? value.sub_total ?? 0) : ""}</P>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
<InvoiceTotal 
  item={invoiceDetail}
  discountAmount={discountAmount}
  finalTotal={finalTotal}
  removeCoupon={removeCoupon}
/>

                                </div>
                        {/* </Col> */}
                    </Row>
                </div>
            </div>
        )
    }
  const handlePageChange = page => {
        fetchCustomer(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomer(page, newPerPage);
        setPerPage(newPerPage);
    };

    const redirectToReciept = (id) => {
        const toReciept = `${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${id}`;
        navigate(toReciept);
    };


    const paymentData = async (page, size = perPage) => {
        setLoading(true);
        let data = await getDataWithToken( getOrderRecentPayment + `?order_id=${orderId}`);
        if (data?.status === true) {
            setSubscriptionList(data.payment.map((e, index) => {
                return {
                    Si: index + 1,
                    Date: <span>{e.created_date}</span>,
                    TransactionId: e.transaction_id,
                    Amount: <span>{e.amount}</span>,
                    Account: e.account_name,
                    Description: e.payment_description,
                    Ref: e.reference,
                    Action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToReciept(e.payment_id) }}>Reciept</Btn>
                            </span>
                        </div >
                }
            }))
            setLoading(false);
        } else if (data?.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data?.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Container>
            <Row>
                <Col sm="12" xl="6 xl-100">
                    <Card>
                        <CardBody>
                            <Nav className="nav-primary" tabs>
                                <NavItem>
                                    <NavLink className={primarycolorTab === '1' ? 'active' : ''} style={{
                                        background: primarycolorTab === '1' ? statusColor : 'transparent',
                                    }}
                                        onClick={() => setprimarycolorTab('1')}>
                                        {invoiceDetail?.payment_status}
                                    </NavLink>
                                </NavItem>
                                
                                   <NavItem>
                                    <NavLink className={primarycolorTab === '2' ? 'active' : ''} onClick={() => setprimarycolorTab('2')}>
                                      Payment History                                    
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={primarycolorTab}>
                                <TabPane tabId="1">
                                    {printSection(invoiceDetail)}
                                </TabPane>
                                <TabPane tabId="2">
                                   <div className="order-history table-responsive" style={{ paddingTop: '30px' }}>
                                        <DataTable
                                            data={subscriptionList}
                                            columns={PaymntColumns}
                                            pagination
                                            progressPending={loading}
                                            paginationServer
                                            defaultSortAsc
                                            paginationTotalRows={totalRows}
                                            paginationDefaultPage={currentPage}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            // conditionalRowStyles={conditionalRow}
                                            onChangePage={handlePageChange}

                                            style={{ border: '1px solid' }}
                                        />
                                    </div>
                                    <P attrPara={{ className: 'mb-0 m-t-30' }} >{ }</P>
                                </TabPane>
                            </TabContent>
                            {/* <Row>
                                {Object.keys(invoiceDetail).length > 0 && (<ProductPlaceOrder item={invoiceDetail} />)}
                            </Row > */}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
});

export default ItemDescription;